import { render } from "./Test.vue?vue&type=template&id=ac296d58"
import script from "./Test.vue?vue&type=script&lang=js"
export * from "./Test.vue?vue&type=script&lang=js"

import "./Test.vue?vue&type=style&index=0&id=ac296d58&lang=css"
script.render = render

export default script